/* Calculateur au m² O'Wall.
   Saisie en mètres (10 ou plus = centimètres), virgule ou point. 1 unité = 0,1 m² = 1 000 cm².
   unités = ceil(largeur_cm × hauteur_cm / 1000), minimum 10 unités (1 m²). Prix = unités × prix de la variante 0,1 m².
   Le bouton renseigne les champs cachés du formulaire produit puis laisse l'ajout AJAX natif d'Impulse l'envoyer. */
(function () {
  'use strict';

  function fr(n, d) {
    return n.toLocaleString('fr-FR', { minimumFractionDigits: d, maximumFractionDigits: d });
  }
  function nombre(raw) {
    var v = String(raw || '').trim().replace(',', '.').replace(/\s/g, '');
    if (!v) return null;
    var n = parseFloat(v);
    return n > 0 ? n : null;
  }
  // "2,8" → 280 cm ; "280" → 280 cm. Centimètres entiers.
  // Seuil > 20 : valeur saisie en cm si > 20 m (cas "280"), sinon considérée en mètres.
  function toCm(raw) {
    var n = nombre(raw);
    if (n === null) return null;
    return Math.round(n > 20 ? n : n * 100);
  }

  function init(root) {
    if (root.dataset.ocInit) return;
    root.dataset.ocInit = '1';

    var $ = function (sel) { return root.querySelector(sel); };
    var W = $('[data-oc-w]'), H = $('[data-oc-h]'), S = $('[data-oc-surface]'), P = $('[data-oc-prix]'),
        M = $('[data-oc-mention]'), E = $('[data-oc-erreur]'), F = $('[data-oc-feedback]'), B = $('[data-oc-submit]'),
        WA = $('[data-oc-wa]'), NB = $('[data-oc-note-toggle]'), N = $('[data-oc-note]'),
        WH = $('[data-oc-wh]'), HH = $('[data-oc-hh]'),
        stage = $('[data-oc-stage]'), wall = $('[data-oc-wall]'), sofa = $('[data-oc-sofa]'),
        CROP = $('[data-oc-crop]'), ZOOM = $('[data-oc-zoom]'), ZMOINS = $('[data-oc-zoom-moins]'),
        ZPLUS = $('[data-oc-zoom-plus]'), ZRESET = $('[data-oc-crop-reset]'),
        PCAD = $('[data-oc-pcad]'), PCADRAW = $('[data-oc-pcadraw]'),
        CW = $('[data-oc-cote-w]'), CH = $('[data-oc-cote-h]'),
        Q = $('[data-oc-qty]'), PL = $('[data-oc-pl]'), PH = $('[data-oc-ph]'), PS = $('[data-oc-ps]'),
        PN = $('[data-oc-pn]'), PC = $('[data-oc-pc]'), T = $('[data-oc-titre]'), C = $('[data-oc-code]');

    var form = document.getElementById(root.dataset.form);
    var select = form ? form.querySelector('[name="id"]') : null;
    if (!form && window.console) console.error('owall-calculateur : formulaire ' + root.dataset.form + ' introuvable, commande en ligne impossible sur cette page');
    var UNITE = parseInt(root.dataset.uniteCentimes, 10) / 100;
    var VARIANT = root.dataset.variantId;
    var WAPP = root.dataset.whatsapp;
    var URL = root.dataset.url;
    var IMAGE = root.dataset.image;
    var LIBELLE = root.dataset.bouton || 'Commander';
    var CODE = (root.dataset.code || '').trim();
    var TITRE = (root.dataset.titre || '').trim();
    var IMG_W = parseInt(root.dataset.imageW, 10) || 0;
    var IMG_H = parseInt(root.dataset.imageH, 10) || 0;
    var state = null;
    var imageChargee = false;
    var minuteur = null;
    // Cadrage choisi par le client : zoom (1 = visuel au plus large) et centre de la fenêtre en fraction du visuel.
    var crop = { zoom: 1, cx: 0.5, cy: 0.5 };

    // Nettoyage du titre et repli sur le code lu dans le titre brut (WT15, WF60, WM76, WD…, WK…).
    if (!CODE) {
      var m = (root.dataset.titreBrut || '').match(/\b(W[A-Z]\d{1,4})\b/i);
      if (m) CODE = m[1].toUpperCase();
    }
    if (CODE) {
      // Le code peut venir d'un SKU libre : échappé avant d'entrer dans la RegExp, et jamais bloquant.
      try {
        TITRE = TITRE.replace(new RegExp('\\b' + CODE.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b', 'i'), '');
      } catch (e) { /* titre laissé tel quel */ }
    }
    TITRE = TITRE.replace(/^[\s\-–—:|·]+|[\s\-–—:|·]+$/g, '').replace(/\s{2,}/g, ' ');
    if (T && TITRE) T.textContent = TITRE;
    if (C && CODE) C.textContent = CODE;
    if (PC) PC.value = CODE;

    var taux = $('[data-oc-taux]');
    if (taux && !isNaN(UNITE)) taux.textContent = fr(UNITE * 10, 0) + ' Dh';

    function hint(el, raw) {
      if (!el) return;
      var n = nombre(raw);
      el.textContent = n !== null && n > 20 ? fr(n, 0) + ' cm = ' + fr(n / 100, 2) + ' m' : '';
    }

    function borne(v, min, max) { return v < min ? min : (v > max ? max : v); }

    // Part du visuel visible dans le mur : au zoom 1 le visuel couvre le mur au plus large, au-delà on entre dedans.
    function fenetre() {
      var rm = state ? state.wc / state.hc : 1.5;
      var ri = IMG_W && IMG_H ? IMG_W / IMG_H : rm;
      var vw, vh;
      if (ri >= rm) { vh = 1; vw = rm / ri; } else { vw = 1; vh = ri / rm; }
      return { vw: borne(vw / crop.zoom, 0.02, 1), vh: borne(vh / crop.zoom, 0.02, 1) };
    }

    function pct(x) { return fr(Math.round(x * 1000) / 10, 1) + ' %'; }

    // Applique le cadrage au mur et le décrit pour le graphiste (rectangle en % du visuel d'origine).
    function majCadrage() {
      if (!wall) return;
      var f = fenetre();
      crop.cx = borne(crop.cx, f.vw / 2, 1 - f.vw / 2);
      crop.cy = borne(crop.cy, f.vh / 2, 1 - f.vh / 2);
      wall.style.backgroundSize = (100 / f.vw) + '% ' + (100 / f.vh) + '%';
      wall.style.backgroundPosition =
        (f.vw >= 0.999 ? 50 : ((crop.cx - f.vw / 2) / (1 - f.vw)) * 100) + '% ' +
        (f.vh >= 0.999 ? 50 : ((crop.cy - f.vh / 2) / (1 - f.vh)) * 100) + '%';
      if (ZOOM && Math.round(crop.zoom * 100) !== parseInt(ZOOM.value, 10)) ZOOM.value = Math.round(crop.zoom * 100);

      if (!PCAD) return;
      if (!state) { PCAD.value = ''; PCAD.disabled = true; if (PCADRAW) { PCADRAW.value = ''; PCADRAW.disabled = true; } return; }
      var x1 = crop.cx - f.vw / 2, y1 = crop.cy - f.vh / 2, x2 = x1 + f.vw, y2 = y1 + f.vh;
      var entier = x1 <= 0.002 && y1 <= 0.002 && x2 >= 0.998 && y2 >= 0.998;
      PCAD.value = entier
        ? 'Visuel entier'
        : 'Largeur ' + pct(x1) + ' à ' + pct(x2) + ', hauteur ' + pct(y1) + ' à ' + pct(y2) + ' du visuel'
          + (crop.zoom > 1.005 ? ' (agrandi ' + fr(crop.zoom, 1) + '×)' : '');
      PCAD.disabled = false;
      if (PCADRAW) {
        PCADRAW.value = [x1, y1, x2, y2].map(function (v) { return Math.round(v * 10000) / 10000; }).join(',');
        PCADRAW.disabled = false;
      }
      majWhatsApp();
    }

    // Aperçu : proportions du mur, canapé de 1,80 m à l'échelle, visuel du produit (dernière photo de la fiche, sans meubles).
    function drawWall(wc, hc) {
      if (!stage || !wall) return;
      var maxW = stage.clientWidth || 300, maxH = stage.clientHeight || 200, r = wc / hc, w, h;
      if (r >= maxW / maxH) { w = maxW; h = maxW / r; } else { h = maxH; w = maxH * r; }
      w = Math.max(24, Math.round(w));
      h = Math.max(24, Math.round(h));
      if (IMAGE && !imageChargee) {
        wall.style.backgroundImage = 'url("' + IMAGE + '")';
        imageChargee = true;
      }
      wall.classList.remove('oc__wall--ghost');
      wall.style.width = w + 'px';
      wall.style.height = h + 'px';
      if (sofa) sofa.style.width = Math.round(Math.min(180 / wc, 0.92) * w) + 'px';
      if (CW) CW.textContent = fr(wc / 100, 2) + ' m';
      if (CH) CH.textContent = fr(hc / 100, 2) + ' m';
      if (CROP && IMAGE) CROP.hidden = false;
      majCadrage();
    }
    function ghostWall() {
      if (!wall) return;
      wall.classList.add('oc__wall--ghost');
      wall.style.width = '300px';
      wall.style.height = '190px';
      if (CROP) CROP.hidden = true;
      if (PCAD) { PCAD.value = ''; PCAD.disabled = true; }
      if (PCADRAW) { PCADRAW.value = ''; PCADRAW.disabled = true; }
    }

    function message() {
      var note = N ? N.value.trim() : '';
      // Le client ne voit pas les chiffres du cadrage : on signale seulement qu'il en a choisi un.
      var cad = PCAD && !PCAD.disabled && PCAD.value && PCAD.value !== 'Visuel entier';
      return "Bonjour O'Wall, je souhaite commander le papier peint " + TITRE + (CODE ? ' (' + CODE + ')' : '') + ' : '
        + fr(state.wc / 100, 2) + ' × ' + fr(state.hc / 100, 2) + ' m, ' + fr(state.u / 10, 1) + ' m², ' + fr(state.prix, 0) + ' Dh.'
        + (cad ? " J'ai choisi un cadrage particulier du visuel." : '')
        + (note ? ' Note : ' + note : '') + ' ' + URL;
    }
    function majWhatsApp() {
      if (!WA) return;
      WA.href = state ? 'https://wa.me/' + WAPP + '?text=' + encodeURIComponent(message()) : 'https://wa.me/' + WAPP;
    }
    function majNote() {
      if (!PN || !N) return;
      var v = N.value.trim();
      PN.value = v;
      PN.disabled = !v;
      majWhatsApp();
    }

    function calc() {
      var wc = toCm(W.value), hc = toCm(H.value);
      hint(WH, W.value);
      hint(HH, H.value);
      E.textContent = '';
      F.textContent = '';
      W.classList.remove('is-invalid');
      H.classList.remove('is-invalid');

      if (wc === null || hc === null) {
        state = null;
        S.textContent = '—';
        P.textContent = '—';
        M.textContent = '';
        B.textContent = LIBELLE;
        Q.value = ''; PL.value = ''; PH.value = ''; PS.value = '';
        ghostWall();
        majWhatsApp();
        return;
      }

      var u = Math.ceil(wc * hc / 1000 - 1e-6), min = false;
      if (u < 10) { u = 10; min = true; }
      state = { wc: wc, hc: hc, u: u, prix: u * UNITE };

      S.textContent = fr(u / 10, 1) + ' m²';
      P.textContent = fr(state.prix, 0) + ' Dh';
      P.classList.remove('is-fresh'); void P.offsetWidth; P.classList.add('is-fresh');
      B.textContent = LIBELLE + ' · ' + fr(state.prix, 0) + ' Dh';
      M.textContent = min ? 'Minimum facturé : 1 m²' : 'Surface arrondie au 0,1 m² supérieur';

      Q.value = u;
      PL.value = fr(wc / 100, 2) + ' m';
      PH.value = fr(hc / 100, 2) + ' m';
      PS.value = fr(u / 10, 1) + ' m²';
      majWhatsApp();
      drawWall(wc, hc);
    }

    function need() {
      if (state) return true;
      E.textContent = 'Entrez la largeur et la hauteur de votre mur';
      var manquant = toCm(W.value) === null ? W : H;
      manquant.classList.add('is-invalid');
      manquant.focus();
      return false;
    }

    function chargement(actif) {
      B.disabled = actif;
      B.classList.toggle('is-loading', actif);
      if (minuteur) { clearTimeout(minuteur); minuteur = null; }
      if (actif) minuteur = setTimeout(function () {
        chargement(false);
        E.textContent = 'Le panier ne répond pas. Réessayez ou commandez sur WhatsApp.';
      }, 10000);
    }

    function commander() {
      if (!need()) return;
      if (!form) {
        E.textContent = 'Commande en ligne indisponible sur cette page. Commandez sur WhatsApp.';
        return;
      }
      majNote();
      if (select && VARIANT) select.value = VARIANT;
      var ajout = root.querySelector('[data-oc-ajout]');
      if (ajout) ajout.value = String(Date.now());
      F.textContent = '';
      chargement(true);
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    }

    // Cadrage : glisser le visuel dans le mur, curseur et boutons pour agrandir, recentrer.
    function zoomer(z, ancre) {
      var avant = fenetre();
      crop.zoom = borne(z, 1, 3);
      var apres = fenetre();
      if (ancre) {
        // garde le point sous le doigt / le curseur au même endroit du visuel
        crop.cx += (ancre.x - 0.5) * (avant.vw - apres.vw);
        crop.cy += (ancre.y - 0.5) * (avant.vh - apres.vh);
      }
      majCadrage();
    }

    if (wall && CROP) {
      var glisse = null;
      wall.addEventListener('pointerdown', function (e) {
        if (CROP.hidden || !state) return;
        glisse = { x: e.clientX, y: e.clientY };
        wall.classList.add('is-dragging');
        if (wall.setPointerCapture) wall.setPointerCapture(e.pointerId);
        e.preventDefault();
      });
      wall.addEventListener('pointermove', function (e) {
        if (!glisse) return;
        var f = fenetre(), largeur = wall.clientWidth || 1, hauteur = wall.clientHeight || 1;
        crop.cx -= ((e.clientX - glisse.x) / largeur) * f.vw;
        crop.cy -= ((e.clientY - glisse.y) / hauteur) * f.vh;
        glisse.x = e.clientX;
        glisse.y = e.clientY;
        majCadrage();
      });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
        wall.addEventListener(ev, function () { glisse = null; wall.classList.remove('is-dragging'); });
      });
      wall.addEventListener('wheel', function (e) {
        if (CROP.hidden || !state) return;
        e.preventDefault();
        var r = wall.getBoundingClientRect();
        zoomer(crop.zoom * (e.deltaY < 0 ? 1.12 : 1 / 1.12), {
          x: borne((e.clientX - r.left) / (r.width || 1), 0, 1),
          y: borne((e.clientY - r.top) / (r.height || 1), 0, 1)
        });
      }, { passive: false });
    }
    if (ZOOM) ZOOM.addEventListener('input', function () { zoomer(parseInt(ZOOM.value, 10) / 100); });
    if (ZMOINS) ZMOINS.addEventListener('click', function () { zoomer(crop.zoom - 0.2); });
    if (ZPLUS) ZPLUS.addEventListener('click', function () { zoomer(crop.zoom + 0.2); });
    if (ZRESET) ZRESET.addEventListener('click', function () { crop.cx = 0.5; crop.cy = 0.5; zoomer(1); });

    W.addEventListener('input', calc);
    H.addEventListener('input', calc);
    [W, H].forEach(function (el) {
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); commander(); }
      });
    });
    B.addEventListener('click', commander);
    if (N) {
      N.addEventListener('input', majNote);
      if (NB) {
        NB.addEventListener('click', function () {
          var ouvert = !N.classList.contains('is-open');
          N.classList.toggle('is-open', ouvert);
          NB.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
          NB.textContent = ouvert ? '– Note pour le graphiste' : '+ Note pour le graphiste';
          if (ouvert) N.focus();
        });
      }
    }
    if (WA) {
      WA.addEventListener('click', function (e) { if (!need()) e.preventDefault(); });
    }

    if (form) {
      // Garde-fou : rien ne part vers /cart/add sans dimensions, quel que soit le déclencheur.
      document.addEventListener('submit', function (e) {
        if (e.target !== form) return;
        if (!state) {
          e.preventDefault();
          e.stopImmediatePropagation();
          chargement(false);
          need();
        }
      }, true);
      form.addEventListener('ajaxProduct:added', function () {
        chargement(false);
        E.textContent = '';
        F.textContent = 'Ajouté au panier : ' + PS.value + ', ' + fr(state ? state.prix : 0, 0) + ' Dh';
      });
      form.addEventListener('ajaxProduct:error', function (e) {
        chargement(false);
        F.textContent = '';
        var d = e.detail && e.detail.errorMessage;
        E.textContent = d ? (typeof d === 'string' ? d : (d.description || d.message || '')) : 'Impossible d’ajouter au panier pour le moment. Réessayez ou commandez sur WhatsApp.';
        if (!E.textContent) E.textContent = 'Impossible d’ajouter au panier pour le moment. Réessayez ou commandez sur WhatsApp.';
      });
    }

    var redessiner = function () { if (state) drawWall(state.wc, state.hc); };
    window.addEventListener('resize', redessiner);
    if (stage && typeof ResizeObserver === 'function') new ResizeObserver(redessiner).observe(stage);

    majWhatsApp();
    calc();
  }

  function initAll() {
    document.querySelectorAll('[data-owall-calculateur]').forEach(function (root) {
      try {
        init(root);
      } catch (e) {
        // Le formulaire natif reste masqué (il vendrait 0,1 m² à 25 Dh) : on le dit et on laisse le bouton WhatsApp.
        if (window.console) console.error('owall-calculateur', e);
        var err = root.querySelector('[data-oc-erreur]');
        if (err) err.textContent = 'Calculateur indisponible pour le moment. Commandez sur WhatsApp ou réessayez plus tard.';
        var btn = root.querySelector('[data-oc-submit]');
        if (btn) btn.disabled = true;
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
